import LnS from "./images/LnS.png";
import swipesmart from "./images/SwipeSmart.png";
import SynapCV from "./images/SynapCV.png";

const CardDetails = [
     {
        title: "SynapCV",
        description: "An agentic, AI-powered interactive resume workspace and live ATS diagnostic engine engineered to bridge the gap between job seekers and Applicant Tracking Systems.",
        imageUrl: SynapCV,
        linkUrl: "https://www.synapcv.com.ng/"
    },
    {
        title: "Luv'N'Scents",
        description: "A full-stack E-commerce perfume sales website fesaturing secure authentication and an intuitive product management system.",
        imageUrl: LnS,
        linkUrl: "https://luvnscents.vercel.app/"
    },
    {
        title: "SwipeSmart",
        description: "An interactive personal finance website that helps users visualize budget goals and forecast future savings based on current spending habits and investment goals.",
        imageUrl: swipesmart,
        linkUrl: "https://swipesmart-snowy.vercel.app/"
       
    },

]

export default CardDetails;